import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Drawer } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useLocation } from "react-router-dom-v5-compat";
import { MainLinksContent } from "./NavDrawerLinkComponents/MainLinksContent";
import { NavDrawerHeader } from "./NavDrawerLinkComponents/NavDrawerHeader";
import { NonAccountPageLinks } from "./NavDrawerLinkComponents/NonAccountPageLinks";
export const NavDrawer = ({ isOpen, setIsOpen }) => {
    var _a;
    const isAccountSection = (_a = useLocation().pathname) === null || _a === void 0 ? void 0 : _a.includes("Account");
    return (_jsx(Drawer, Object.assign({ anchor: "left", open: isOpen, onClose: () => setIsOpen(false) }, { children: _jsxs(Box, Object.assign({ role: "presentation", onClick: () => setIsOpen(false), onKeyDown: () => setIsOpen(false), style: { minWidth: "250px" } }, { children: [_jsx(NavDrawerHeader, { setIsOpen: setIsOpen }), _jsx(Stack, Object.assign({ spacing: 2, 
                    // Prevents border from being cutoff
                    paddingTop: 0.125 }, { children: !isAccountSection ? _jsx(NonAccountPageLinks, {}) : _jsx(MainLinksContent, {}) }))] })) })));
};
